import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface StartInspectionGpsVerificationProps {
  isEnabled: boolean;
  locationMessageKey: string | null;
  locationMessageClassName?: string;
}

export const StartInspectionGpsVerification: FC<StartInspectionGpsVerificationProps> = ({
  isEnabled,
  locationMessageKey,
  locationMessageClassName,
}) => {
  const { t } = useTranslation();
  if (!isEnabled) {
    return null;
  }
  if (!locationMessageKey) {
    return null;
  }
  return <p className={locationMessageClassName}>{t(locationMessageKey)}</p>;
};
